import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isNull } from "lodash";
import React from "react";
import { Link } from "react-router-dom";
const ConfigureCommunicationField = (props) => {
  const {
    data,
    height,
    width,
    border,
    padding,
    onClickNavigate,
    borderRadius,
    backgroundColor,
    isCommunication = true,
    style = {},
    errorMessage = null,
  } = props;
  return (
    <>
      <div
        onClick={() => onClickNavigate()}
        className="d-flex justify-content-center align-items-center configure-communication-fields primary-border"
        style={{
          width: width,
          padding: padding,
          height: height,
          border: border,
          cursor: "pointer",
          borderRadius: borderRadius,
          backgroundColor: backgroundColor,
          ...style,
        }}
      >
        {isCommunication ? (
          <FontAwesomeIcon
            className="primary-color"
            icon={faPlus}
            size="md"
            style={{
              paddingRight: "2px",
              marginRight: "10px",
            }}
          />
        ) : (
          <i
            class="far fa-plus-square primary-color"
            style={{
              paddingRight: "2px",
              marginRight: "10px",
            }}
          ></i>
        )}
        <div className="primary-color">{data}</div>
      </div>
      {!isNull(errorMessage) && (
        <div className="error-message mt-md-3">{errorMessage}</div>
      )}
    </>
  );
};

export default ConfigureCommunicationField;
